import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "toolbar" }
const _hoisted_3 = { class: "pager" }

import { ref, reactive, onMounted } from "vue";
import { ElMessage } from "element-plus";
import { TenantServiceApi } from "@/services/dataService";


export default /*@__PURE__*/_defineComponent({
  __name: 'TenantManagement',
  setup(__props) {

const loading = ref(false);
const items = ref<any[]>([]);
const total = ref(0);
const query = reactive({ page: 1, page_size: 10 });
const filters = reactive<{
  name: string | undefined;
  subname: string | undefined;
  is_active: boolean | undefined;
}>({ name: undefined, subname: undefined, is_active: undefined });

const dialog = reactive({
  visible: false,
  isEdit: false,
  editingId: null as null | string,
});
const form = reactive<any>({
  name: "",
  subname: "",
  description: "",
  contact_name: "",
  contact_email: "",
  contact_phone: "",
  max_devices: 10000,
  is_active: true,
  api_enabled: false,
  api_rate_limit: 100,
});

const loadTenants = async () => {
  loading.value = true;
  try {
    const params: any = { page: query.page, page_size: query.page_size };
    if (filters.name) params.name = filters.name;
    if (filters.subname) params.subname = filters.subname;
    if (filters.is_active !== undefined) params.is_active = filters.is_active;
    const resp = await TenantServiceApi.listTenants(params);
    const data = resp?.data?.data;
    items.value = data?.items || [];
    total.value = data?.total || 0;
  } catch (e: any) {
    ElMessage.error(e?.message || "加载失败");
  } finally {
    loading.value = false;
  }
};

const resetFilters = () => {
  filters.name = undefined;
  filters.subname = undefined;
  filters.is_active = undefined;
};

const openCreate = () => {
  dialog.visible = true;
  dialog.isEdit = false;
  dialog.editingId = null;
  Object.assign(form, {
    name: "",
    subname: "",
    description: "",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
    max_devices: 10000,
    is_active: true,
    api_enabled: false,
    api_rate_limit: 100,
  });
};

const openEdit = (row: any) => {
  dialog.visible = true;
  dialog.isEdit = true;
  dialog.editingId = row.id;
  Object.assign(form, { ...row });
};

const submit = async () => {
  try {
    const payload: any = {
      name: form.name,
      subname: form.subname,
      description: form.description,
      contact_name: form.contact_name,
      contact_email: form.contact_email,
      contact_phone: form.contact_phone,
      max_devices: form.max_devices,
      is_active: form.is_active,
      api_enabled: form.api_enabled,
      api_rate_limit: form.api_rate_limit,
    };
    if (dialog.isEdit && dialog.editingId) {
      const resp = await TenantServiceApi.updateTenant(
        dialog.editingId,
        payload
      );
      if (resp?.data?.code === 0) {
        ElMessage.success("已更新");
        dialog.visible = false;
        loadTenants();
        return;
      }
    } else {
      const resp = await TenantServiceApi.createTenant(payload);
      if (resp?.data?.code === 0) {
        ElMessage.success("已创建");
        dialog.visible = false;
        loadTenants();
        return;
      }
    }
    ElMessage.error("提交失败");
  } catch (e: any) {
    ElMessage.error(e?.message || "提交失败");
  }
};

const removeTenant = async (row: any) => {
  try {
    const resp = await TenantServiceApi.deleteTenant(row.id);
    if (resp?.data?.code === 0) {
      ElMessage.success("已删除");
      loadTenants();
    } else {
      ElMessage.error(resp?.data?.message || "删除失败");
    }
  } catch (e: any) {
    ElMessage.error(e?.message || "删除失败");
  }
};

onMounted(loadTenants);

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        modelValue: filters.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.name) = $event)),
        placeholder: "租户名称",
        clearable: "",
        class: "mr8"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        modelValue: filters.subname,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.subname) = $event)),
        placeholder: "子域名",
        clearable: "",
        class: "mr8"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        modelValue: filters.is_active,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.is_active) = $event)),
        placeholder: "状态",
        clearable: "",
        class: "mr8",
        style: {"width":"140px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            value: true,
            label: "启用"
          }),
          _createVNode(_component_el_option, {
            value: false,
            label: "停用"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: loadTenants
      }, {
        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
          _createTextVNode("查询", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "ml8",
        onClick: resetFilters
      }, {
        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
          _createTextVNode("重置", -1)
        ]))]),
        _: 1
      }),
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "flex1" }, null, -1)),
      _createVNode(_component_el_button, {
        type: "success",
        onClick: openCreate
      }, {
        default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
          _createTextVNode("新建租户", -1)
        ]))]),
        _: 1
      })
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: items.value,
      size: "small",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "名称",
          "min-width": "160"
        }),
        _createVNode(_component_el_table_column, {
          prop: "subname",
          label: "子域名",
          "min-width": "140"
        }),
        _createVNode(_component_el_table_column, {
          prop: "is_active",
          label: "状态",
          width: "90"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: scope.row.is_active ? 'success' : 'info'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.is_active ? "启用" : "停用"), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "api_enabled",
          label: "API",
          width: "90"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: scope.row.api_enabled ? 'success' : 'info'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.api_enabled ? "开启" : "关闭"), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "api_rate_limit",
          label: "限流(次/分)",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "max_devices",
          label: "最大设备数",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "220",
          fixed: "right"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              size: "small",
              onClick: ($event: any) => (openEdit(scope.row))
            }, {
              default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                _createTextVNode("编辑", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_popconfirm, {
              title: "确认删除该租户？",
              onConfirm: ($event: any) => (removeTenant(scope.row))
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "danger"
                }, {
                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                    _createTextVNode("删除", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onConfirm"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_pagination, {
        background: "",
        layout: "prev, pager, next, jumper, total",
        total: total.value,
        "page-size": query.page_size,
        "current-page": query.page,
        onCurrentChange: _cache[3] || (_cache[3] = (p)=>{query.page=p; loadTenants()})
      }, null, 8, ["total", "page-size", "current-page"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialog.visible,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((dialog.visible) = $event)),
      title: dialog.isEdit ? '编辑租户' : '新建租户',
      width: "560px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[14] || (_cache[14] = ($event: any) => (dialog.visible = false))
        }, {
          default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
            _createTextVNode("提交", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: form,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.name,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "子域名" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.subname,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.subname) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "描述" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.description,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.description) = $event)),
                  type: "textarea"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "联系人" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.contact_name,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.contact_name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "邮箱" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.contact_email,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.contact_email) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "电话" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.contact_phone,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.contact_phone) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "最大设备数" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: form.max_devices,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.max_devices) = $event)),
                  min: 0
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "启用" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: form.is_active,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.is_active) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "API启用" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: form.api_enabled,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.api_enabled) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "API限流" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: form.api_rate_limit,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.api_rate_limit) = $event)),
                  min: 0
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})